/**
 * Perche' una voce letta dall'IA sulla foto dell'etichetta va ricontrollata
 * (chip "Da controllare" nel form e nel gate di revisione, DEV-375):
 * - `PERCENT_UNREADABLE`: percentuale poco leggibile o scartata dal server;
 * - `ALLERGEN_UNKNOWN`: allergene non riconosciuto o sostanza non precisata;
 * - `NESTING_UNSURE`: non e' chiaro dentro quale voce sta.
 */
export const COMPONENT_REVIEW_REASONS = [
  'PERCENT_UNREADABLE',
  'ALLERGEN_UNKNOWN',
  'NESTING_UNSURE',
] as const;

export type ComponentReviewReason = (typeof COMPONENT_REVIEW_REASONS)[number];
